import axios from "axios";
import User from "../../models/user.model";

const BASE_API = process.env.REACT_APP_BASE_API;

axios.defaults.withCredentials = +process.env.REACT_APP_LOCAL !== 1;

export type SignupResponseType = {
    data: {
        status: boolean;
        token: string;
        user: User;
        msg: string;
        response: any;
    }
}

export const signupRequest = async (payload: {email: string, password: string, name: string})
    :Promise<SignupResponseType | {data: {status: boolean}}> => {
    try {
        return await axios.post(`${BASE_API}/auth/signup`, payload);
    } catch (error) {
        return errorHandler(error);
    }
}

export const verifyEmailRequest = async (token: string, code: string) => {
    try {
        return await axios.post(`${BASE_API}/auth/verify-email/${token}`, {code});
    } catch (error) {
        return errorHandler(error);
    }
}

export const resendVerifyEmailRequest = async (token: string) => {
    try {
        return await axios.post(`${BASE_API}/auth/resend-verify-email/${token}`);
    } catch (error) {
        return errorHandler(error);
    }
}

export const signinRequest = async (email: string, password: string) => {
    try {
        return await axios.post(`${BASE_API}/auth/signin`, {email, password});
    } catch (error) {
        return errorHandler(error);
    }
}

export const changeWalletRequest = async (wallet: string) => {
    try {
        return await axios.put(`${BASE_API}/users/`, {wallet})
    } catch (error) {
        return errorHandler(error);
    }
}

export const changeNameRequest = async (name: string) => {
    try {
        return await axios.put(`${BASE_API}/users/name`, {name});
    } catch (error) {
        return errorHandler(error);
    }
}

export const changePasswordRequest = async (old: string, newPassword: string) => {
    try {
        return await axios.post(`${BASE_API}/users/change-password`, {old, new: newPassword});
    } catch (error) {
        return errorHandler(error);
    }
}

export const change2FARequest = async (method: string) => {
    try {
        return await axios.post(`${BASE_API}/auth/request-tfa`, {method})
    } catch (error) {
        return errorHandler(error);
    }
}

export const confirm2FARequest = async (token: string, code: string, method: string) => {
    try {
        return await axios.post(`${BASE_API}/auth/confirm-tfa/${token}`, {code, method});
    } catch (error) {
        return errorHandler(error);
    }
}

export const tfaForLoginRequest = async (token: string, code: string) => {
    try {
        return await axios.post(`${BASE_API}/auth/login-tfa/${token}`, {code});
    } catch (error) {
        return errorHandler(error);
    }
}

export const AutoLoginRequest = async (accessToken: string) => {
    try {
        return await axios.post(`${BASE_API}/auth/me`, null, {
            headers: {
                Authorization: `Bearer ${accessToken}`
            }
        });
    } catch (error) {
        return errorHandler(error);
    }
}

export const resetPasswordRequest = async (email: string) => {
    try {
        return await axios.post(`${BASE_API}/auth/reset-password`, {email});
    } catch (error) {
        return errorHandler(error);
    }
}

export const resetPasswordConfirmRequest = async (token: string, code: string, newPassword: string) => {
    try {
        return await axios.post(`${BASE_API}/auth/reset-password/${token}`, {
            code, password: newPassword
        })
    } catch (error) {
        return errorHandler(error);
    }
}

export const activateUserRoles = async (role: string, activate: number) => {
    try {
        const token = localStorage.getItem("accessToken");
        const headers = {
          Authorization: `Bearer ${token}`,
        };
        return await axios.put(
            `${BASE_API}/users/activate-roles`,
            { role: role, activate: activate },
            { headers }
        );
    } catch (error) {
        return errorHandler(error);
    }
}

const errorHandler = (error: any) => {
    const _error = error as any;
    return {data: {status: false, response: _error.response?.data}};
}
